// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"559":"ef85a491","607":"ef85a491"}[chunkId] + ".chunk.css";
};